import { render, staticRenderFns } from "./MyCollect.vue?vue&type=template&id=7207c575&"
import script from "./MyCollect.vue?vue&type=script&lang=js&"
export * from "./MyCollect.vue?vue&type=script&lang=js&"
import style0 from "./MyCollect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports